import { HeatmapLayer } from '@deck.gl/aggregation-layers'
import { CompositeLayer } from '@deck.gl/core'
import { MVTLayer } from '@deck.gl/geo-layers'
import { IconLayer } from '@deck.gl/layers'
import { isMobile } from 'react-device-detect'
import { FeatureType } from 'stores/features'

class BuildingsimulationLayer extends CompositeLayer<any, any> {
  public readonly type = FeatureType.Building

  constructor(props) {
    super(props)
  }

  shouldUpdateState({ props, changeFlags }) {
    if (!changeFlags.propsChanged) {
      return false
    }

    if (changeFlags.propsChanged === 'props.mvtProps changed shallowly') {
      return true
    }

    if (changeFlags.propsChanged === 'props.dataUrl changed shallowly') {
      return true
    }

    return false
  }

  initializeState() {
    super.initializeState()

    this.setState({
      subLayerData: [],
      loadedTiles: {
        ids: []
      }
    })
  }

  *generateLayers(tile) {
    const { loadedTiles } = this.state
    const tmp = tile.dataInWGS84.filter(
      (e) => !loadedTiles.ids.includes(e.properties.uuid)
    )

    if (tmp.length > 0) {
      yield tmp
    }
  }

  _addSubLayerData(tile: any) {
    const { subLayerData, loadedTiles } = this.state
    const tileId = JSON.stringify(tile.bbox)

    if (loadedTiles[tileId]) {
      return
    }

    for (const layers of this.generateLayers(tile)) {
      this.setState({
        loadedTiles: {
          ...loadedTiles,
          ids: loadedTiles.ids.concat(layers.map((e) => e.properties.uuid)),
          [tileId]: true
        },
        subLayerData: subLayerData.concat(layers)
      })
    }
  }

  renderLayers() {
    const { subLayerData } = this.state

    return [
      new MVTLayer(this.props.mvtProps, {
        id: `${this.props.id}-mvt`,
        data: this.props.dataUrl,
        maxCacheSize: 100000000,
        maxRequests: 5,
        onTileLoad: (e) => {
          this._addSubLayerData(e)
        }
      }),
      this.props.iconProps?.visible &&
        new IconLayer(this.props.iconProps, {
          id: `${this.props.id}-icon`,
          data: subLayerData,
          pickable: this.props.pickable,
          opacity: this.props.opacity,
          billboard: this.props.billboard,
          getIcon: this.props.getIcon,
          getPosition: this.props.iconProps.getPosition
        }),
      this.props.heatmapProps?.visible &&
        new HeatmapLayer({
          ...this.props.heatmapProps,
          id: `${this.props.id}-heatmap`,
          data: subLayerData,
          weightsTextureSize: 1024,
          radiusPixels: !isMobile ? 12 : 5,
          intensity: !isMobile ? 1 : 1.5,
          opacity: 0.3,
          getPosition: this.props.getPosition
        })
    ]
  }
}

BuildingsimulationLayer.layerName = 'BuildingsimulationLayer'

BuildingsimulationLayer.defaultProps = {
  getIcon: {
    type: 'accessor',
    value: () => {
      return 'marker'
    }
  },
  pickable: true,
  billboard: true,
  opacity: 1,
  getPosition: {
    type: 'accessor',
    value: (d: any) => {
      // will be replaced by centroid coordinates from backend calculation
      const coords = d.geometry.coordinates[0]
      const latLng = [0, 0]

      for (const coord of coords) {
        latLng[0] += coord[0]
        latLng[1] += coord[1]
      }

      return [latLng[0] / coords.length, latLng[1] / coords.length]
    }
  }
}

export default BuildingsimulationLayer
